/**
 * Question field types — mirror of the backend QuestionType enum.
 */
export enum QuestionType {
    TEXT_FIELD = 'TEXT_FIELD',
    TEXT_AREA = 'TEXT_AREA',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    RATING = 'RATING',
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    VIDEO_SINGLE = 'VIDEO_SINGLE',
    FILES_MULTIPLE = 'FILES_MULTIPLE',
    VIDEO_LIVE_RECORD = 'VIDEO_LIVE_RECORD',
}

export enum QuestionnaireStatus {
    DRAFT = 'draft',
    ACTIVE = 'active',
    ARCHIVED = 'archived',
}

export interface Question {
    id?: string;
    type: QuestionType;
    label: string;
    helpText?: string;
    isRequired: boolean;
    order: number;
    options?: string[];
    maxDurationSeconds?: number;
    maxFiles?: number;
    acceptedFileTypes?: string[];
}

export interface Questionnaire {
    _id: string;
    title: string;
    description?: string;
    difficultyLevel: number;
    duration?: number;
    status: QuestionnaireStatus;
    proId?: string | null;
    pro?: { _id: string; commercialName: string } | null;
    questions: Question[];
    jobOffers?: { _id: string; title: string; jobNumber: string }[];
    createdAt?: string;
    updatedAt?: string;
}

export interface QuestionnaireInput {
    title: string;
    description?: string;
    difficultyLevel: number;
    duration?: number;
    status?: QuestionnaireStatus;
    proId?: string | null;
    questions: Array<Omit<Question, 'id'>>;
}

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
    [QuestionType.TEXT_FIELD]: 'Champ texte',
    [QuestionType.TEXT_AREA]: 'Zone de texte',
    [QuestionType.MULTIPLE_CHOICE]: 'Choix multiples',
    [QuestionType.RATING]: 'Notation (1-5)',
    [QuestionType.SINGLE_CHOICE]: 'Choix unique',
    [QuestionType.VIDEO_SINGLE]: 'Vidéo (1 fichier)',
    [QuestionType.FILES_MULTIPLE]: 'Fichiers multiples',
    [QuestionType.VIDEO_LIVE_RECORD]: 'Enregistrement vidéo en direct',
};

export const QUESTIONNAIRE_STATUS_LABELS: Record<QuestionnaireStatus, string> = {
    [QuestionnaireStatus.DRAFT]: 'Brouillon',
    [QuestionnaireStatus.ACTIVE]: 'Actif',
    [QuestionnaireStatus.ARCHIVED]: 'Archivé',
};

export const createEmptyQuestion = (order = 0): Question => ({
    type: QuestionType.TEXT_FIELD,
    label: '',
    helpText: '',
    isRequired: false,
    order,
    options: [],
    maxDurationSeconds: undefined,
    maxFiles: undefined,
    acceptedFileTypes: [],
});

export const createEmptyQuestionnaire = (): Questionnaire => ({
    _id: '',
    title: '',
    description: '',
    difficultyLevel: 5,
    duration: undefined,
    status: QuestionnaireStatus.DRAFT,
    questions: [],
});
